import { useState, useEffect } from "react";
import client from './utils/sanity/client.ts';
import { Link, useParams } from "react-router-dom";
import BlockContent from "@sanity/block-content-to-react";
import { format } from "date-fns";
import './Blog.css';
import { Helmet } from "react-helmet";
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function BlogDetails() {

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const [singlePost, setSinglePost] = useState([])
  const { slug } = useParams()
  useEffect(() => {
    client.fetch(`*[slug.current == "${slug}"] {
      title,
      slug,
      body,
      publishedAt,
      mainImage {
        asset -> {
          _id,
          url
        },
        alt,
      },
      "name": author->name,
    }`).then((data) => setSinglePost(data[0])).catch(console.error)
  }, [slug])


  return <>
    <div className="bio-details-container">
      <Helmet>
        <title>News - {slug}</title>
        <meta name="description" content="Check in here to read Aethel's latest fantasy stories, inspired by fairytales and stories of old." />

        {/* Page-Specific Open Graph Tags */}
        <meta property="og:title" content={`News - ${slug}`} />
        <meta property="og:description" content="Check in here to read Aethel's latest fantasy stories, inspired by fairytales and stories of old." />
        <meta property="og:image" content="%PUBLIC_URL%/images/BiopicMedium.png"  />
        <meta property="og:url" content={`https://aethel.vercel.app/book/${slug}`} />

        {/* Page-Specific Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`News - ${slug}`} />
        <meta name="twitter:description" content="Check in here to read Aethel's latest fantasy stories, inspired by fairytales and stories of old." />
        <meta name="twitter:image" content="%PUBLIC_URL%/images/BiopicMedium.png"  />
      </Helmet>
      <h1>{singlePost.title}</h1>
      <section className="blog-container">
        <div className="blog-body-container">
          <div className="image-date-container">
            {singlePost.mainImage && singlePost.mainImage.asset && (
              <LazyLoadImage src={singlePost.mainImage.asset.url} alt={singlePost.title} effect="blur" />
            )}

            {singlePost.publishedAt && (
              <small>
                By {singlePost.name} on{" "} {format(new Date(singlePost.publishedAt), "dd MMMM yyyy")}
              </small>
            )}</div>
          <div className="body-container">
            <BlockContent
              blocks={singlePost.body}
              projectId="pcafmc1n"
              dataset="production"
              className="custom-block-content"
            /></div>

          <Link to="/blog"><button>More News</button></Link>
        </div>
      </section>
    </div>
  </>
}
